import { render } from "./ClockSquareIcon.vue?vue&type=template&id=6b8bf177"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__